export default __webpack_public_path__ + "static/media/Burn-In2.65b050f0.gif";